import getMinigameByName from "./getMinigameByName";
import StrongCont from "./order/Continue/Strong";
import {alltasks, tasks} from "./ImportMinigames";
import nextRound from "./minigames/restartTasks/countSelect";
import finishRound from "./minigameProcess/finalMinigame";
import endGame from "./minigames/endGame/endGame";

var MinigamesConfig = {
	type: "standart",
	initMinigames: tasks,
	minigames: alltasks,
	service: [finishRound, nextRound, endGame],
	constraints: [
	]
};

MinigamesConfig.allMinigameNames = MinigamesConfig.minigames.map(mg => mg.name);

MinigamesConfig.getMinigameByName = getMinigameByName;
MinigamesConfig.ruleset = {};
MinigamesConfig.fatal = {};

MinigamesConfig.ruleset.theme = {
	'Заставка': {
		tasks: ['task_0', 'task_0_4', 'task_0_1', 'task_0_2'],
		move: StrongCont,
	}
};

export default MinigamesConfig;